var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "reporting-call-logs-header" }, [
      _c("div", { staticClass: "reporting-call-logs-header__title" }, [
        _vm._v("\n      Call Details\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "reporting-call-logs-header__right reporting-call-logs-header__right--overflow"
        },
        [
          _vm.adminViewingAsAdmin
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm m-r-5",
                  attrs: { disabled: !_vm.selectedCalls.length },
                  on: { click: _vm.clearRowSelection }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-minus clear-btn__icon--center"
                  }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("CLEAR_CALLS_SELECTION")) +
                      "\n      "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.adminViewingAsAdmin
            ? _c(
                "dropdown",
                {
                  staticClass: "bulk-actions-dropdown m-r-10",
                  attrs: { tag: "span", "menu-right": true }
                },
                [
                  _c("btn", { attrs: { type: "primary", size: "sm" } }, [
                    _c("span", { staticClass: "text-uppercase" }, [
                      _vm._v("\n            Edit calls "),
                      _vm.selectedCalls.length
                        ? _c("span", [
                            _vm._v("(" + _vm._s(_vm.selectedCalls.length) + ")")
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "caret m-l-5" })
                  ]),
                  _vm._v(" "),
                  _c("template", { slot: "dropdown" }, [
                    _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.left",
                            value: _vm.generalEditTooltip,
                            expression: "generalEditTooltip",
                            modifiers: { left: true }
                          }
                        ]
                      },
                      [
                        _vm.adminViewingAsAdmin
                          ? _c(
                              "a",
                              {
                                staticClass: "btn bulk-actions-dropdown__btn",
                                attrs: {
                                  role: "button",
                                  disabled: !_vm.selectedCalls.length
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showBulkForm("tagAnnotate")
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-pencil fa-fw" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("ANNOTATE")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.left",
                            value: _vm.generalEditTooltip,
                            expression: "generalEditTooltip",
                            modifiers: { left: true }
                          }
                        ]
                      },
                      [
                        _vm.adminViewingAsAdmin
                          ? _c(
                              "a",
                              {
                                staticClass: "btn bulk-actions-dropdown__btn",
                                attrs: {
                                  role: "button",
                                  disabled: !_vm.selectedCalls.length
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showBulkForm("blockNumber")
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-ban fa-fw" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("BLOCK_NUMBER")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.left",
                            value: _vm.paymentEditTooltip,
                            expression: "paymentEditTooltip",
                            modifiers: { left: true }
                          }
                        ]
                      },
                      [
                        _vm.adminViewingAsAdmin
                          ? _c(
                              "a",
                              {
                                staticClass: "btn bulk-actions-dropdown__btn",
                                attrs: {
                                  role: "button",
                                  disabled:
                                    _vm.outsideAdjustmentRange &&
                                    !_vm.selectedCalls.length
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showBulkForm("callAdjustment")
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-usd" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("ADJUST_PAYMENT")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.left",
                            value: _vm.transcribeEditTooltip,
                            expression: "transcribeEditTooltip",
                            modifiers: { left: true }
                          }
                        ]
                      },
                      [
                        _vm.adminViewingAsAdmin
                          ? _c(
                              "a",
                              {
                                staticClass: "btn bulk-actions-dropdown__btn",
                                attrs: {
                                  role: "button",
                                  disabled:
                                    _vm.outsideAdjustmentRange &&
                                    !_vm.selectedCalls.length
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showBulkForm("transcribeCalls")
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-file-text-o" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("TRANSCRIBE")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm m-l-10",
              attrs: {
                id: "reporting-call-logs__column_btn",
                title: _vm.$t("CUSTOMIZE_COLUMNS")
              },
              on: { click: _vm.toggleCallLogsColumnsPanel }
            },
            [
              _c("i", { staticClass: "fa fa-columns p-r-0" }),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "CUSTOMIZE_COLUMNS",
                    expression: "'CUSTOMIZE_COLUMNS'"
                  }
                ],
                staticClass: "hidden-xs p-l-5"
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "dropdown",
            {
              staticClass: "bulk-actions-dropdown",
              attrs: { tag: "span", "menu-right": true }
            },
            [
              _c(
                "btn",
                {
                  attrs: {
                    size: "sm",
                    "data-cy": "button__csv_json_export_dropdown"
                  }
                },
                [_c("span", { staticClass: "caret" })]
              ),
              _vm._v(" "),
              _c("template", { slot: "dropdown" }, [
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "btn bulk-actions-dropdown__btn",
                      attrs: { role: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("resetColumnState")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-undo fa-fw" }),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("RESET_COLUMN_STATE")) +
                          "\n            "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "btn bulk-actions-dropdown__btn",
                      attrs: {
                        role: "button",
                        "data-cy": "button__export-json-settings"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("exportReportJSONRequestBody")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-download fa-fw" }),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("EXPORT_JSON_SETTINGS")) +
                          "\n            "
                      )
                    ]
                  )
                ])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _vm.canExportReport
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm m-l-10 btn-loader btn-loader--sm",
                  attrs: { disabled: _vm.noCallsData || _vm.showExportLoader },
                  on: { click: _vm.exportReport }
                },
                [
                  _c("span", {
                    staticClass: "fa fa-download p-0 m-l-4 visible-xs-inline",
                    class: { invisible: _vm.showExportLoader }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "hidden-xs" }, [
                    _vm._v(_vm._s(_vm.$t("EXPORT_CSV")))
                  ]),
                  _vm._v(" "),
                  _c("Loader", {
                    attrs: {
                      "custom-class": "size-sm m-b-5 btn-export-loader",
                      "loader-class": _vm.showExportLoader ? "" : "invisible"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ag-grid-call-logs__container" },
      [
        _c(
          "a",
          {
            staticClass: "ag-grid-call-logs__collapse-right-pinned-btn",
            on: { click: _vm.togglePinnedColumns }
          },
          [
            _c("i", {
              staticClass: "fa",
              class: {
                "fa-chevron-left": _vm.isPinnedCollapsed,
                "fa-chevron-right": !_vm.isPinnedCollapsed
              }
            })
          ]
        ),
        _vm._v(" "),
        _vm.showTagAnnotationBulkForm
          ? _c("BulkTagAnnotate", {
              attrs: {
                "selected-calls": _vm.selectedCalls,
                "show-loader": _vm.showBulkActionLoader,
                "recent-tags": _vm.recentCallTags
              },
              on: {
                close: _vm.hideBulkForm,
                annotateCalls: _vm.annotateMultipleCalls,
                unselectCallOnBulkAction: _vm.unselectCallOnBulkAction
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.showBlockNumberBulkForm
          ? _c("BulkBlockNumbers", {
              attrs: {
                "show-loader": _vm.showBulkActionLoader,
                "selected-calls": _vm.selectedCalls
              },
              on: {
                close: _vm.hideBulkForm,
                bulkBlockNumbers: _vm.handleBulkBlockNumbers,
                unselectCallOnBulkAction: _vm.unselectCallOnBulkAction
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.showAdjustCallPaymentBulkForm
          ? _c("BulkCallAdjustmentForm", {
              attrs: {
                "show-loader": _vm.showBulkActionLoader,
                "selected-calls": _vm.selectedCalls,
                "is-admin": _vm.isAdmin,
                "total-calls-count": _vm.totalCallsCount,
                "pending-bulk-call-adjustment-by-logs":
                  _vm.pendingBulkCallAdjustmentByLogs
              },
              on: {
                close: _vm.hideBulkForm,
                bulkCallAdjustment: _vm.handleBulkCallAdjustment,
                bulkCallAdjustmentByLogs: _vm.handleBulkCallAdjustmentByLogs,
                unselectCallOnBulkAction: _vm.unselectCallOnBulkAction
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.showTranscribeCallsBulkForm
          ? _c("BulkTranscriptionForm", {
              attrs: {
                "show-loader": _vm.showBulkActionLoader,
                "selected-calls": _vm.selectedCalls,
                "is-admin": _vm.isAdmin,
                "total-calls-count": _vm.totalCallsCount
              },
              on: {
                close: _vm.hideBulkForm,
                bulkCallTranscription: _vm.handleBulkCallTranscription,
                bulkCallTranscriptionByLogs:
                  _vm.handleBulkCallTranscriptionByLogs,
                unselectCallOnBulkAction: _vm.unselectCallOnBulkAction
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.showBulkActionForm
          ? _c("div", { staticClass: "ag-grid__overlay" })
          : _vm._e(),
        _vm._v(" "),
        _c("AgGridVue", {
          staticClass:
            "ag-grid--custom ag-grid--call-logs ag-theme-balham-dark",
          class: {
            "ag-grid--call-logs--show-right-arrow": _vm.showRightScrollArrow,
            "ag-grid--call-logs--show-left-arrow": _vm.showLeftScrollArrow,
            "ag-grid--call-logs--hide-pinned-columns": _vm.isPinnedCollapsed // Keep right scroll arrow shown when right pinned header is hidden
          },
          attrs: {
            context: _vm.context,
            "default-col-def": _vm.defaultColDef,
            "column-defs": _vm.computedColDefs,
            "column-types": _vm.columnTypes,
            "row-model-type": "serverSide",
            "cache-block-size": 150,
            "row-height": 29.6,
            "detail-cell-renderer": _vm.detailCellRenderer,
            "master-detail": true,
            "framework-components": _vm.frameworkComponents,
            components: _vm.components,
            "loading-cell-renderer": _vm.loadingCellRenderer,
            "loading-cell-renderer-params": _vm.loadingCellRendererParams,
            "side-bar": _vm.sideBar,
            "suppress-column-move-animation": true,
            "get-row-node-id": _vm.getRowNodeId,
            "suppress-context-menu": true,
            "block-load-debounce-millis": 400,
            "row-buffer": _vm.rowBuffer,
            "suppress-column-state-events": false,
            "suppress-property-names-check": true,
            "suppress-animation-frame": true,
            "group-header-height": 0,
            "get-main-menu-items": _vm.getMainMenuItems,
            "overlay-no-rows-template":
              "No calls to display. Try selecting a different date range or filter settings.",
            "tooltip-show-delay": 0,
            "row-selection": "multiple",
            "row-multi-select-with-click": true,
            "suppress-row-click-selection": true
          },
          on: {
            firstDataRendered: _vm.onFirstDataRendered,
            "grid-ready": _vm.onGridReady,
            sortChanged: _vm.onGridStateChange,
            columnVisible: _vm.onColumnVisibilityChanged,
            columnMoved: _vm.onColumnMoved,
            columnPinned: _vm.onColumnsPinned,
            columnResized: _vm.onColumnResized,
            cellClicked: _vm.onCellClicked,
            "grid-size-changed": _vm.onGridSizeChanged,
            bodyScroll: _vm.onBodyScroll,
            cellMouseOver: _vm.onCellMouseOver,
            cellMouseOut: _vm.onCellMouseOut
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }